import UserService from "services/User.service";

const wirelessConfig = {
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks.read": {
    protocol: "ws",
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wireless.wirelessData",
  },
  "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wireless.wirelessData",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks.update": {
    protocol: "ws",
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks",
    restful: true,
    method: "update",
    buildParams: null,
    action: null,
    mockSelector: "wireless.wirelessData",
  },
  "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks",
    restful: true,
    method: "update",
    buildParams: null,
    action: null,
    mockSelector: "wireless.wirelessData",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId/clients.read":
    {
      protocol: "ws",
      resource:
        "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId/clients",
      restful: true,
      method: "read",
      buildParams: null,
      action: null,
      mockSelector: "wireless.clientsData",
    },
  "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId/clients.read":
    {
      protocol: "ws",
      resource:
        "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId/clients",
      restful: true,
      method: "read",
      buildParams: null,
      action: null,
      mockSelector: "wireless.clientsData",
    },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId.update":
    {
      protocol: "ws",
      resource:
        "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId",
      restful: true,
      method: "update",
      buildParams: (params) => ({ data: params.updates }),
      action: null,
      mockSelector: "wireless.wirelessData",
    },
  "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId.update":
    {
      protocol: "ws",
      resource:
        "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId",
      restful: true,
      method: "update",
      buildParams: (params) => ({ data: params.updates }),
      action: null,
      mockSelector: "wireless.wirelessData",
    },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks.create": {
    protocol: "ws",
    resource:
      "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "wireless.wirelessData",
  },
  "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "wireless.wirelessData",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId.delete":
    {
      protocol: "ws",
      resource:
        "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId",
      restful: true,
      method: "delete",
      buildParams: (params) => ({
        entId: params.entId,
        orgId: params.orgId,
        siteId: params.siteId,
        wirelessNetworkId: params.wirelessNetworkId,
      }),
      action: null,
      mockSelector: "wireless.wirelessData",
    },
  "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId.delete":
    {
      protocol: "ws",
      resource:
        "/orgs/:orgId/sites/:siteId/settings/wirelessNetworks/:wirelessNetworkId",
      restful: true,
      method: "delete",
      buildParams: (params) => ({
        orgId: params.orgId,
        siteId: params.siteId,
        wirelessNetworkId: params.wirelessNetworkId,
      }),
      action: null,
      mockSelector: "wireless.wirelessData",
    },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radio.read":
    {
      protocol: "ws",
      resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radio",
      restful: true,
      method: "read",
      buildParams: (params) => null,
      action: null,
      mockSelector: "wirelessRadio",
    },
  "/orgs/:orgId/sites/:siteId/settings/radio.read":
    {
      protocol: "ws",
      resource: "/orgs/:orgId/sites/:siteId/settings/radio",
      restful: true,
      method: "read",
      buildParams: (params) => null,
      action: null,
      mockSelector: "wirelessRadio",
    },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radio.update":
    {
      protocol: "ws",
      resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radio",
      restful: true,
      method: "update",
      buildParams: (params) => params,
      action: null,
      mockSelector: "wirelessRadio",
    },
  "/orgs/:orgId/sites/:siteId/settings/radio.update":
    {
      protocol: "ws",
      resource: "/orgs/:orgId/sites/:siteId/settings/radio",
      restful: true,
      method: "update",
      buildParams: (params) => params,
      action: null,
      mockSelector: "wirelessRadio",
    },
};

export default wirelessConfig;
